import { ClientFactories, Store } from 'bernie-core';
import { ClientLogger } from 'bernie-client';

import {
  PageTitleStore,
  SearchResultsStore,
  DialogsStore,
  BannersStore,
  ErrorStore,
  ListingsStore,
  SearchFormStore,
  SearchCriteriaStore,
  SortFilterStore,
  AdvertisingStore,
  OpinionLabStore,
  ClientMetadataStore,
  FlightInformationStore,
  FreeCancellationStore,
  InformationCriteriaStore,
  InformationResultStore,
  MessagingCardsStore,
  FlexibleSearchResultsStore,
  FlexibleSearchStore,
  PriceSummaryStore,
  PoliciesStore,
  FlightsSelectedJourneyReviewStore,
  CheapestListingInfoStore,
  DynamicElementsStore,
  StepIndicatorStore,
  GaiaIdStore
} from './';
import { ApiOperations } from 'src/__generated__/api';

const { getLoggerWithIdentifier } = ClientLogger;
export const stores: ClientFactories = {
  pageTitleStore: () => {
    return new PageTitleStore({}, getLoggerWithIdentifier('store.pageTitle'));
  },
  opinionLabStore: () => {
    return new OpinionLabStore({}, getLoggerWithIdentifier('store.opinionLab'));
  },
  searchResults: options => {
    return new SearchResultsStore(ApiOperations.withClient, {}, getLoggerWithIdentifier('store.searchResults'), {
      'Device-User-Agent-ID': options.bexApiContext.identity.duaid
    });
  },
  dialogsStore: () => {
    return new DialogsStore({}, getLoggerWithIdentifier('store.dialogs'));
  },
  bannersStore: () => {
    return new BannersStore({}, getLoggerWithIdentifier('store.banners'));
  },
  errorStore: () => {
    return new ErrorStore(ErrorStore.DEFAULTS, getLoggerWithIdentifier('store.error'));
  },
  listingsStore: () => {
    return new ListingsStore({}, getLoggerWithIdentifier('store.listings'));
  },
  sortFilterStore: () => {
    return new SortFilterStore({}, getLoggerWithIdentifier('store.sortFilter'));
  },
  searchFormStore: () => {
    return new SearchFormStore({}, getLoggerWithIdentifier('store.searchForm'));
  },
  searchCriteriaStore: () => {
    return new SearchCriteriaStore({}, getLoggerWithIdentifier('store.searchCriteria'));
  },
  advertisingStore: () => {
    return new AdvertisingStore({}, getLoggerWithIdentifier('pwa.flight.advertising'));
  },
  clientMetadataStore: () => {
    return new ClientMetadataStore({}, getLoggerWithIdentifier('store.clientMetadata'));
  },
  flightInformationStore: (): Store => {
    return new FlightInformationStore({}, getLoggerWithIdentifier('store.flightInformationStore'));
  },
  informationResult: options => {
    return new InformationResultStore(
      ApiOperations.withClient,
      {},
      getLoggerWithIdentifier('store.informationResult'),
      { 'Device-User-Agent-ID': options.bexApiContext.identity.duaid }
    );
  },
  freeCancellationStore: (): Store => {
    return new FreeCancellationStore({}, getLoggerWithIdentifier('store.freeCancellation'));
  },
  informationCriteriaStore: () => {
    return new InformationCriteriaStore({}, getLoggerWithIdentifier('store.informationCriteria'));
  },
  messagingCardsStore: () => {
    return new MessagingCardsStore({}, getLoggerWithIdentifier('store.messagingCardsStore'));
  },
  priceSummaryStore: (): Store => {
    return new PriceSummaryStore({}, getLoggerWithIdentifier('store.priceSummary'));
  },
  policiesStore: (): Store => {
    return new PoliciesStore({}, getLoggerWithIdentifier('store.policiesStore'));
  },
  flexibleSearchResultsStore: (): Store => {
    return new FlexibleSearchResultsStore({}, getLoggerWithIdentifier('store.flexibleSearchResultsStore'));
  },
  flexibleSearchStore: options => {
    return new FlexibleSearchStore(ApiOperations.withClient, {}, getLoggerWithIdentifier('store.flexibleSearchStore'), {
      'Device-User-Agent-ID': options.bexApiContext.identity.duaid
    });
  },
  flightsSelectedJourneyReviewStore: (): Store => {
    return new FlightsSelectedJourneyReviewStore(
      {},
      getLoggerWithIdentifier('store.flightsSelectedJourneyReviewStore')
    );
  },
  cheapestListingInfoStore: () => {
    return new CheapestListingInfoStore({}, getLoggerWithIdentifier('store.cheapestListingInfoStore'));
  },
  dynamicElementsStore: (): Store => {
    return new DynamicElementsStore({}, getLoggerWithIdentifier('store.dynamicElementsStore'));
  },
  stepIndicatorStore: (): Store => {
    return new StepIndicatorStore({}, getLoggerWithIdentifier('store.stepIndicatorStore'));
  },
  gaiaIdStore: (): Store => {
    return new GaiaIdStore({}, getLoggerWithIdentifier('store.gaiaIdStore'));
  }
};
